<template>
  <b-button
    id="nextButton"
    class="btn btn-square btn-primary"
    :disabled="isDisabled"
    @click="goNext"
  >
    Next
  </b-button>
</template>

<script>
export default {
    // data () {
    //     return {
    //         isDisabled: true
    //     }
    // }
    props: {
        isDisabled: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        goNext() {
            this.$parent.$emit('goNext')
        }
    }
}
</script>

<style lang="scss" scoped>
    #nextButton {
        position: absolute;
        right: 5vw;
        bottom: 5vw;
    }
</style>